import api from "@/lib/api"

export async function novaSolicitacao(formData) {
  const { data } = await api.post("/secretaria-digital/solicitacao", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data
}

export async function getPassword(cpf, data_nascimento, empresaId) {
  const { data } = await api.post("/aluno/get-password", { cpf, birthDate:data_nascimento, empresaId }, {
    headers: { "Content-Type": "application/json" }
  });
  return data
}

